/**
 * SIM-1816: derive avatar initials for the header account menu. Prefer the first+second letter of a
 * full name, else the first letter of the name, else the first letter of the email. `PortalUser`
 * currently carries no name, so today this resolves to the email's first letter — but the name path
 * is honored if/when a name field is added.
 */
export function userInitials(email: string, name?: string | null): string {
  const trimmed = name?.trim();
  if (trimmed) {
    const parts = trimmed.split(/\s+/);
    if (parts.length >= 2 && parts[0] && parts[1]) {
      return (parts[0][0] + parts[1][0]).toUpperCase();
    }
    if (parts[0]) return parts[0][0].toUpperCase();
  }
  return (email.trim()[0] ?? "?").toUpperCase();
}
